import { countries } from "./lib";
import { createSlice } from "@reduxjs/toolkit";
import buildAction from "../../helpers/buildAction.ts";
import thunks from "./thunks";
import reducers from "./reducers";
import { INumberSlice } from "@/redux/slices/numbers/types";

export const initialState: INumberSlice = {
  countries: countries.map((country) => ({
    ...country,
    area_codes: [],
  })),
  numbers: {
    standard: {
      loading: false,
      page: 0,
      total_count: 0,
      total_pages: 0,
      numbers: [],
    },
    premium: {
      loading: false,
      page: 0,
      total_count: 0,
      total_pages: 0,
      numbers: [],
    },
    nonGeo: {
      loading: false,
      page: 0,
      total_count: 0,
      total_pages: 0,
      numbers: [],
    },
  },
  options: {
    showAdvanced: false,
    countryCode: "",
    numberType: "",
    areaCode: "",
    numberCategory: "all",
    startsWith: "",
    contains: "",
    endsWith: "",
    limit: 20,
  },
  inclusive: {
    cart_remaining: 0,
    inclusive_remaining: 0,
  },
};

export const numbersSlice = createSlice({
  name: "numbers",
  initialState,
  reducers,
  extraReducers: (builder) => {
    thunks.forEach((thunk) => buildAction(builder, thunk));
  },
});

export default numbersSlice.reducer;
export const { changeNumberOption, changeNumberCategory, clearNumbers } =
  numbersSlice.actions;
